import { parseAsStringEnum, useQueryState } from "@beztack/state";
import { useParams, useSearchParams } from "react-router";
import { usePublicMenu } from "@/hooks/use-menu";
import {
  deriveFulfillmentVariant,
  enabledFulfillmentTypes,
  type FulfillmentType,
} from "./public-menu-flow-model";
import { PublicMenuFlowView } from "./public-menu-flow-view";
import { usePublicMenuFlow } from "./use-public-menu-flow";

const FULFILLMENT_QUERY_PARAM = "fulfillment";
const FULFILLMENT_QUERY_VALUES = ["dine-in", "delivery", "takeaway"];

export default function PublicMenuFlowPage() {
  const { orgSlug } = useParams();
  const [searchParams] = useSearchParams();
  const qrToken = searchParams.get("t");
  const [fulfillment, setFulfillment] = useQueryState(
    FULFILLMENT_QUERY_PARAM,
    parseAsStringEnum(FULFILLMENT_QUERY_VALUES).withDefault("dine-in"),
  );
  const menuQuery = usePublicMenu(orgSlug);

  const enabledTypes = menuQuery.data
    ? enabledFulfillmentTypes({
        businessType: menuQuery.data.organization.businessType,
        orderingEnabled: menuQuery.data.organization.orderingEnabled,
        deliveryEnabled: menuQuery.data.organization.deliveryEnabled,
      })
    : ([] as FulfillmentType[]);
  const isQrDineIn = Boolean(qrToken);
  const variant = deriveFulfillmentVariant({
    fulfillmentParam: fulfillment,
    enabledTypes,
    isQrDineIn,
  });

  const flow = usePublicMenuFlow(
    variant === "dine-in"
      ? { variant: "dine-in", orgSlug, qrToken: qrToken ?? null }
      : variant === "delivery"
        ? { variant: "delivery", orgSlug }
        : { variant: "takeaway", orgSlug },
  );

  return <PublicMenuFlowView flow={flow} onFulfillmentChange={setFulfillment} />;
}
